module.exports = __webpack_public_path__ + "img/shujuchaxun.c6a8f385.png";